// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prepayment_detail[data-v-6cebb9ac] {\n  padding-left: 50px;\n}\n.prepayment_detail .text-red[data-v-6cebb9ac] {\n  color: #f56c6c !important;\n}\n.prepayment_detail[data-v-6cebb9ac] .vxe-footer--row {\n  background-color: #f5f7fa;\n  color: #606266;\n}\n", ""]);
// Exports
module.exports = exports;
